<template>
	<div>
		<h1 class="mb-2">Calendar</h1>
		<hr>
		
		<div class="row">
			<div class="col-6">
				<label class="mr-3" style="font-size:14px;font-weight:bold;">Calendar View Type</label>
				<toggle-button 
					v-model="type"
					:width="150"
					:height="30"
					color="#7dCE94" 
					:sync="true" 
					:labels="{checked: 'Calendar View', unchecked: 'Event View'}"
				/>
			</div>
			
			<div class="col-3 offset-3 mt-auto mb-auto">
				<div class="w-100 text-right mb-2">
					<button
						class="btn btn-primary btn-md"
						@click="modal.add = true;"
					>
						Add Individual Event
					</button>
					<button
						class="btn btn-info ml-3 btn-md"
						@click="modal.addBulk = true;"
					>
						Add Bulk Event
					</button>
				</div>
			</div>
			

		
		</div>
		
		<template v-if="type">
			<div class="w-25 border border-secondary rounded p-10 mb-3">
				<h5>Legend :</h5>
					
				<div class="row ">
					<div class="col-3">
						<div class="dot" style="background-color:#fed8d7"></div>
					</div>
					<div class="col-9">
						<span>Holiday</span>
					</div>
				</div>
				<div class="row ">
					<div class="col-3">
						<div class="dot" style="background-color:#c7f6d6"></div>
					</div>
					<div class="col-9">
						<span>Working Day</span>
					</div>
				</div>
			</div>

			<Calendar
				v-if="events.length > 0"
				class="w-100"
				:columns="$screens({ default: 1, lg: 4 })"
				:rows="$screens({ default: 1, lg: 3 })"
				is-expanded
				:from-date="thisYear"
				:attributes="events"
				is-range
				value="range"
				ref="calendar"
				@dayclick="selectDate"
			>
			</Calendar>
		</template>

		<template v-else >
			<div class="border border-secondary shadow rounded p-10">
				<table class="table text-center">
					<thead>
						<th>Dates</th>
						<th>Event Description</th>
						<th><i class="fa fa-cog"></i></th>
					</thead>
					<tbody v-for="(event , index) in events" :key="index">
						<tr v-if="event.holiday != 0 && event.popover.label != 'hari minggu'">
							<td><b>{{moment(event.dates.start).format("ddd DD MMM, Y")}}</b> to <b>{{moment(event.dates.end).format('ddd DD MMM, Y')}}</b></td>
							<td>{{event.popover.label}}</td>
							<td>
								<button class="btn btn-danger" @click="deleteEvent(event.dates)"><i class="fa fa-times"></i></button>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</template>

		<add-calendar-event
			v-if="modal.add"
			@closeModal="modal.add = false;dateSelected = null"
			@onSuccess="getEvents()"
			:dateSelected="dateSelected"
		></add-calendar-event>

		<add-bulk-event 
			v-if="modal.addBulk"
			@onSuccess="getEvents()"
			@closeModal="modal.addBulk = false;"
		/>
		
	</div>
</template>

<script>
import Calendar from 'v-calendar/lib/components/calendar.umd'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'

import { ToggleButton } from 'vue-js-toggle-button'
import moment from 'moment'

import addCalendarEvent from './children/addCalendarEvent'
import addBulkEvent from './children/addBulkEvent.vue'

export default {
	components : {
		Calendar,
		DatePicker,
		ToggleButton,
		addCalendarEvent,
		addBulkEvent
	},
	data () {
		const month = new Date().getMonth();
		const year = new Date().getFullYear();
		const thisYear = new Date(year , 0 , 1)
		
		return { 
			modal : {
				add : false,
				addBulk : false
			},
			type : true,
			year : year,
			thisYear : thisYear,
			masks: {
				weekdays: 'WWW',
			},
			events : [],
			range : {
				start : null,
				end : null
			},
			moment : moment
		}
	},
	watch : {
		range : function () {
			console.log(this.range)
		},
		// type : function () {
		// 	if(this.type) console.log(this.$refs.calendar)
		// }
	},
	mounted () {
		this.getEvents()
		console.log(this.$refs.calendar)
	},
	//start(YYYY-MM-DD), end, note(string), holiday (1,0)
	methods : {
		selectDate (value) {
			this.dateSelected = value.id
			this.modal.add = true
		},
		getEvents () {
			this.events.length = 0;
			this.$http.get('/api/setting/calendar')
			.then((resp) => {
				let data = resp.data.data

				for(var i = 0 ; i < data.length ; i++) {
					let obj = {
						key : i,
						dates : { start : new Date(data[i].start) , end : new Date(data[i].end)},
						popover: { 
							label : data[i].note == '' ? 'Hari Kerja' : data[i].note,
							visibility : 'hover'
						},
						holiday : data[i].holiday
					}

					if(data[i].holiday == 0) {
						obj.highlight = {
							start: { fillMode: 'none' , color : 'green' },
							base: { fillMode: 'light' ,  color : 'green' },
							end: { fillMode: 'none' ,  color : 'green'  },
						}
					}
					else {
						obj.highlight = {
							start: { fillMode: 'none' , color : 'red' },
							base: { fillMode: 'light' ,  color : 'red' },
							end: { fillMode: 'none' ,  color : 'red'  },
						}
					}
					this.events.push(obj)
				}

			
			})
		},
		deleteEvent(target) {
			let start = moment(target.start).format('Y-MM-DD')
			let end = moment(target.end).format('Y-MM-DD')

			this.$swal.fire({
				title: 'Do you want to delete event permanently?',
				type : 'warning',
				showCancelButton: true,
				confirmButtonText: `Delete`,
			}).then((result) => {
				/* Read more about isConfirmed, isDenied below */
				if (result.value) {
					
					this.$http.delete('/api/setting/calendar' , {data : {start , end}})
					.then((resp) => {
						this.getEvents()
					})
					.catch((err) => {
						console.log(err)
					})
				}
			})
		}
	}
}
</script>
<style scoped>

	.middle {
		margin-top : auto;
		margin-bottom: auto;
	}

	.dot {
		border: 1px solid black;
		height: 10px;
		width: 10px;
		display: inline-block;
	}
</style>
